module.exports = __webpack_public_path__ + "img/chain.92d6540f.svg";